// extracted by mini-css-extract-plugin
module.exports = {"bubble":"Bubble_bubble__3LY7B","tri":"Bubble_tri__1irT_"};